document.addEventListener("DOMContentLoaded", function() {

    class CartWatcher {

        init() {
          this.emitCartChanges().then(() => {
            this.observeCartChanges();
          });
        }
      
        async fetchCart() {
          const response = await fetch('/cart.js');
          return response.json();
        }
      
        storeCart(cart) {
          localStorage.setItem('cart', JSON.stringify(cart));
        }
      
       storedCart() {
          return JSON.parse(localStorage.getItem('cart')) || { items: [] };
        }
      
       findCartChanges(oldCart, newCart) {
          const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
          let result = {
            added: onlyInLeft(newCart.items, oldCart.items),
            removed: onlyInLeft(oldCart.items, newCart.items),
          };
      
          oldCart.items.forEach(oi => {
            const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
            if (!ni) return;
            let quantity = ni.quantity - oi.quantity;
            let item = { ...ni };
            item.quantity = Math.abs(quantity);
            quantity > 0
              ? result.added.push(item)
              : result.removed.push(item)
          });
      
          return result;
        }
      
        async emitCartChanges() {
          const newCart = await this.fetchCart();
          const oldCart = this.storedCart();
          const changes = this.findCartChanges(oldCart, newCart);
      
          const event = new CustomEvent("cart_changed", { detail: changes });
          document.dispatchEvent(event);
      
          this.storeCart(newCart);
        }
      
        observeCartChanges() {
          let debounceTimeout;
          const debounceEmitCartChanges = () => {
              clearTimeout(debounceTimeout);
              debounceTimeout = setTimeout(() => {
                  this.emitCartChanges();
              }, 200);
          };
      
          const cartObserver = new PerformanceObserver((list) => {
              list.getEntries().forEach((entry) => {
                  const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                  const isCartChangeRequest = /\/cart\//.test(entry.name);
                  if (isValidRequestType && isCartChangeRequest) {
                      debounceEmitCartChanges();
                  }
              });
          });
          cartObserver.observe({ entryTypes: ["resource"] });
        }
      
    }

    // cart add on

    const csCartAddon = document.querySelector('#csCartAddon')
    const csCartAddonOption = document.querySelector('#csCartAddonOption')
    const csCartAddonButton = document.querySelector('#csCartAddonButton')    
    const csVariantImage = document.querySelectorAll('.cs-variant-image')

    csCartAddonOption.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex]
        const variantId = selectedOption.getAttribute('variant-id')
        csCartAddon.setAttribute('data-variant-id', variantId)
        if (variantId) {
            csVariantImage.forEach((image) => {
                const currentVariantId = image.getAttribute('dataid')
                if (variantId != currentVariantId) {
                    image.classList.remove('active')
                } else {
                    image.classList.add('active')
                }
            })
        }
    })

    function initCartAddon() {

        // csCartAddonButton.disabled = true

        const product_id = parseInt(csCartAddon.getAttribute('data-product-id'))        

        let variant_id = parseInt(csCartAddon.getAttribute('data-variant-id'))
        const csMatchingOption = csCartAddonOption.querySelector(`option[variant-id="${variant_id}"]`)

        if (csMatchingOption) {
            csMatchingOption.selected = true;
        }

        const csCartAddonTitle = document.querySelector('#csCartAddonTitle')
        const csCartAddonTitleSecond = document.querySelector('#csCartAddonTitleSecond')                        

        let totalQuantity = 0
        const finalQuantity = 1

        fetch('/cart.json')
            .then(response => response.json())
            .then(cartData => {
                totalQuantity = cartData.items
                    .filter(item => item.product_id === product_id)
                    .reduce((sum, item) => sum + item.quantity, 0)

                console.log('totalQuantity ' + totalQuantity)

                if (totalQuantity >= 3 || totalQuantity == 0) {
                    // csCartAddon.classList.remove('active')
                    csCartAddon.classList.add('hidden')
                    // csCartAddonButton.disabled = true
                } else {
                    // csCartAddon.classList.add('active')
                    csCartAddon.classList.remove('hidden')
                    // csCartAddonButton.disabled = false
                }

                if (totalQuantity == 1) {
                    csCartAddonTitle.classList.add('active')
                    csCartAddonTitleSecond.classList.remove('active')
                } else if (totalQuantity == 2) {
                    csCartAddonTitle.classList.remove('active')
                    csCartAddonTitleSecond.classList.add('active')
                }

                csCartAddonButton.setAttribute('data-final-quantity', finalQuantity);

        })
        .catch(error => console.error('Error fetching cart data:', error))
        
        function reloadSection(sectionSelector, url) {
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newContent = doc.querySelector(sectionSelector);

                    if (newContent) {
                        document.querySelector(sectionSelector).innerHTML = newContent.innerHTML;
                    }
                })
                .catch(error => console.error("Error reloading section:", error));
        }

        csCartAddonButton.addEventListener('click', function(e) {

            const new_variant_id = parseInt(csCartAddon.getAttribute('data-variant-id'))

            e.preventDefault()
            
            let formData = {
            'items': [{
                'id': new_variant_id,
                'quantity': 1
                }]
            };
                
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                reloadSection(".cart-drawer__item-list", "/");
                return response.json(); 
            })
            .catch((error) => {
                console.error('Error:', error);
            });

        })

    }

    const myCartWatcher = new CartWatcher;
    myCartWatcher.init();

    document.addEventListener("cart_changed", e => {
      initCartAddon()
    })

})